import Emitter from "es6-event-emitter";

import language from "./../../dictionary";
import about from "./../../templates/settings/settingAbout.dust";
import APIManager from "./../../utilities/apimanager";
import { version as platformVersion } from "../../../../package.json";

import SettingIFrame from "./settingIFrame";

import {
  OPENED_ABOUT_SETTINGS,
  CLICKED_BACK_ABOUT,
  CLICKED_CLOSE_ABOUT,
  CLICKED_DISCLAIMER_SETTINGS,
  CLICKED_UUID_SETTINGS,
  CLICKED_EDITOR_SETTINGS,
  CLICKED_DEVELOPER_SETTINGS,
} from "./../../analytics/analyticsevents";

import {
  DISCLAIMER,
  CONTACT_TWIPE,
  CONTACT_CLIENT,
} from "./../../utilities/redirectorKeys";
import { hideLoaderAndChangeLocation } from "../../utilities/location";

export default class SettingAbout extends Emitter {
  appState = null;
  options = null;
  sessionManager = null;

  constructor(appState, sessionManager, options) {
    super();
    this.appState = appState;
    this.sessionManager = sessionManager;
    this.options = options;
    this.render();
    this.fetchSettingsUrls();
  }

  render() {
    const context = {};
    context.back = true;
    context.close = true;

    context.about = language.about;

    context.disclaimer = language.disclaimer;

    context.version = language.version;
    context.currentVersion = this.appState.buildVersion;

    context.platformversion = language.platformversion;
    context.currentPlatformversion = platformVersion;

    context.uuid = language.uuid;
    context.currentUuid = this.sessionManager.UUID;

    context.editor = language.editor;
    context.currentEditor = this.options.editor;

    context.developer = language.developer;
    context.currentDeveloper = this.options.developer;
    context.hideDisclaimer = this.options.hideDisclaimer;

    //render layout with context
    this.DOMContainer = document.querySelector("#sidemenu-about-container");
    if (this.DOMContainer !== null) {
      Dust.render(about, context, (err, result) => {
        this.DOMContainer.innerHTML = result;

        this.attachClickHandlers();

        this.show();
      });
    }
  }

  attachClickHandlers() {
    const backButton = this.DOMContainer.querySelector(
      ".overlay-navigation-back .overlay-navigation-icon"
    );
    if (backButton) {
      backButton.addEventListener("click", (e) => {
        this.onBackButtonClick(e);
      });
    }

    const closeButton = this.DOMContainer.querySelector(
      ".overlay-navigation-close .overlay-navigation-icon"
    );
    if (closeButton) {
      closeButton.addEventListener("click", (e) => {
        this.onCloseButtonClick(e);
      });
    }

    const disclaimer = this.DOMContainer.querySelector(".about-disclaimer");
    if (disclaimer) {
      disclaimer.addEventListener("click", (e) => {
        this.onDisclaimerClick(e);
      });
    }

    const uuid = this.DOMContainer.querySelector(".about-uuid");
    if (uuid) {
      uuid.addEventListener("click", (e) => {
        this.onUuidClick(e);
      });
    }

    const editor = this.DOMContainer.querySelector(".about-editor");
    if (editor) {
      editor.addEventListener("click", (e) => {
        this.onEditorClick(e);
      });
    }

    const developer = this.DOMContainer.querySelector(".about-developer");
    if (developer) {
      developer.addEventListener("click", (e) => {
        this.onDeveloperClick(e);
      });
    }
  }

  fetchSettingsUrls() {
    APIManager.getRedirectorUrl(
      CONTACT_CLIENT,
      this.appState.buildVersion,
      this.appState.userId,
      this.appState.downloadToken
    )
      .then((result) => {
        this.editorUrl = result;
      })
      .catch(() => {});

    APIManager.getRedirectorUrl(
      CONTACT_TWIPE,
      this.appState.buildVersion,
      this.appState.userId,
      this.appState.downloadToken
    )
      .then((result) => {
        this.developperUrl = result;
      })
      .catch(() => {});

    if (!this.options.hideDisclaimer) {
      APIManager.getRedirectorUrl(
        DISCLAIMER,
        this.appState.buildVersion,
        this.appState.userId,
        this.appState.downloadToken
      )
        .then((result) => {
          this.disclaimerUrl = result;
        })
        .catch(() => {});
    }
  }
  onEditorClick() {
    this.appState.triggerEvent(CLICKED_EDITOR_SETTINGS);
    this._openInNewtab(this.editorUrl);
  }

  onDeveloperClick() {
    this.appState.triggerEvent(CLICKED_DEVELOPER_SETTINGS);
    this._openInNewtab(this.developperUrl);
  }

  onDisclaimerClick() {
    if (this.appState.isDesktop || this.options.openHelpOnNewtab) {
      this._openInNewtab(this.disclaimerUrl);
    } else {
      if (this.disclaimer && !this.disclaimer.isEmpty()) {
        this.disclaimer.show();
      } else {
        this.disclaimer = new SettingIFrame(
          this.appState,
          document.querySelector("#sidemenu-disclaimer-container"),
          "disclaimer",
          language.disclaimer,
          this.disclaimerUrl,
          this.options
        );
        this.disclaimer.on("settingIframe:closed", () => {
          this.close();
        });
      }
    }
    this.appState.triggerEvent(CLICKED_DISCLAIMER_SETTINGS);
  }

  onBackButtonClick(e) {
    e.stopPropagation();
    this.hide();
    this.appState.triggerEvent(CLICKED_BACK_ABOUT);
  }

  onCloseButtonClick(e) {
    e.stopPropagation();
    this.close();
    this.appState.triggerEvent(CLICKED_CLOSE_ABOUT);
  }

  onUuidClick() {
    this.sentDeviceInfo();
    this.appState.triggerEvent(CLICKED_UUID_SETTINGS);
  }

  close() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.classList.add("hidden");
    }
    this.trigger("settingAbout:closed");
  }

  hide() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.classList.add("hidden");
    }
  }

  show() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.classList.remove("hidden");
    }
    this.appState.triggerEvent(OPENED_ABOUT_SETTINGS);
  }

  sentDeviceInfo() {
    const subject = "device info webapp";

    const version = this.appState.buildVersion;
    const uuid = this.sessionManager.UUID;
    const userAgent = navigator.userAgent;
    const client = process.env.CLIENT;
    const userId = this.sessionManager.session.SessionInfo.UserId;
    const sessionId = this.sessionManager.session.SessionInfo.SessionId;
    const username = this.appState.username
      ? `userName: ${this.appState.username}`
      : "";

    const url =
      "mailto:?subject=" +
      subject +
      "&body=" +
      "version: " +
      version +
      "%0D%0A" +
      "branch: " +
      process.env.BRANCH +
      "%0D%0A" +
      "platformversion: " +
      process.env.PLATFORM_VERSION +
      "%0D%0A" +
      "uuid: " +
      uuid +
      "%0D%0A" +
      "client: " +
      client +
      "%0D%0A" +
      "userId: " +
      userId +
      "%0D%0A" +
      "sessionId: " +
      sessionId +
      "%0D%0A" +
      "userAgent: " +
      userAgent +
      "%0D%0A" +
      username;

    hideLoaderAndChangeLocation(url, window);
  }

  _openInNewtab(url) {
    const newWindow = window.open(url, "_blank");
    newWindow.focus();
  }
}



// WEBPACK FOOTER //
// ./src/common/components/settings/settingAbout.js